import { Box, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import styled from "styled-components";

import muiStyled from "@mui/system/styled";

// This is commented out because the component will be hide until further notice.
// import { Link } from "react-router-dom";
// const bulbIcon = "./assets/icon/icons/bulb.svg";
// const featureArrow = "./assets/icon/images/right-arrow.svg";

export const useScreenWidthRange = (min: number, max: number): boolean => {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(min-width: ${min}px) and (max-width: ${max}px)`
    );

    const updateMatch = () => setMatches(mediaQuery.matches);
    updateMatch();

    mediaQuery.addEventListener("change", updateMatch);
    return () => mediaQuery.removeEventListener("change", updateMatch);
  }, [min, max]);

  return matches;
};

export const getBaseUrl = (): string => {
  const host = window.location.hostname;
  if (host.includes("dev")) return "https://dev.app.majura.ai";
  if (host.includes("staging")) return "https://staging.app.majura.ai";
  if (host.includes("localhost")) return "https://dev.app.majura.ai";
  return "https://app.majura.ai";
};

const LandingOne = () => {
  return (
    <LandingSection id={"main-section"}>
      <HeroSection />

      {/* <FeatureContainer>
        <FeatureCard />
      </FeatureContainer> */}
    </LandingSection>
  );
};

const LandingSection = styled.section`
  width: 100%;
  padding-top: 100px;
  max-height: fit-content;
  position: relative;
`;

const HeroSection = () => {
  const signInUrl = `${getBaseUrl()}`;
  const isMobile = useScreenWidthRange(0, 768);
  const isTablet = useScreenWidthRange(768, 1024);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const targetElement = document.getElementById("contact-section");

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    } else {
      console.error(`Element with ID '${"contact-section"}' not found.`);
    }
  };

  return (
    <HeroBox>
      <Stack direction={isMobile || isTablet ? "column" : "row"} sx={{ width: "100%" }}>
        <LeftContent>
          <LeftContainerStack direction={"column"} spacing={"24px"}>
            <TitleContainer>
              <Title>
                Move Freight,
                <DesktopBreak /> Not Paperwork
              </Title>
            </TitleContainer>
            <Description>
              Save time and cost with our AI logistics assistant; we automate
              the forms, filings, and follow-ups, so you can focus on growing
              your business.
            </Description>
            <ButtonStack direction={isMobile ? "column" : "row"} spacing={"24px"}>
              <PrimaryButton>
                <BookDemoLink onClick={handleClick}>
                  Start Your 60-Day Free Trial
                </BookDemoLink>
              </PrimaryButton>
              <SecondaryButton>
                <SignInLink href={signInUrl}>Sign-In</SignInLink>
              </SecondaryButton>
            </ButtonStack>
          </LeftContainerStack>
        </LeftContent>

        <RightContent>
          <DashboardImageContainer>
            <a
              href={"./assets/img/web_mobile_dashboard.webp"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <DashboardImage
                src={"./assets/img/web_mobile_dashboard.webp"}
                alt="Dashboard"
              />
            </a>
          </DashboardImageContainer>
        </RightContent>
      </Stack>

      <BottomDecoration />
      <BottomDecoration2 />
    </HeroBox>
  );
};

const HeroBox = muiStyled(Box)(({ theme }) => ({
  background:
    "linear-gradient( 83deg, #002671 24.11%, #002366 48.07%, #001e51 79.35%)",
  color: "white",
  position: "relative",
  overflow: "hidden",
  zIndex: "4"
}));

const LeftContainerStack = muiStyled(Stack)(({ theme }) => ({
  width: "100%",
  marginTop: "50px",
  alignItems: "center",
  [theme.breakpoints.up("lg")]: {
    alignItems: "flex-start"
  }
}));

const ButtonStack = muiStyled(Stack)(({ theme }) => ({
  justifyContent: "center",
  padding: "0px 24px",
  [theme.breakpoints.up("md")]: {
    padding: "0px"
  },
  [theme.breakpoints.up("lg")]: {
    justifyContent: "flex-start"
  }
}));

const Description = styled.div`
  color: white;
  font-size: 1.2rem;

  @media (max-width: 1025px) {
    max-width: 100%;
    margin-top: 0.5rem;
    text-align: center;
    padding: 0px 32px;
    font-size: 1rem;
  }
`;

const RoundedGradientButton = styled.div`
  height: 51px;
  width: 100%;
  border-radius: 0;
  overflow: hidden;
  position: relative;
  @include transition(all, 0.5s, ease);
  font-weight: 600;
  border-radius: 30px;
  z-index: 0;
  margin-right: 20px;
  background: linear-gradient(to right, #9d8cff 0%, #3edcff 100%);
  display: inline-block;
  text-align: center;
  padding: 3px;
  color: #fff;
  line-height: 51px;

  :hover,
  &:focus {
    color: #fff;
  }
  &:active {
    outline: 0;
    box-shadow: none;
  }
  &:hover {
    color: #fff;
    &:after {
      height: 100%;
      width: 135%;
    }
  }

  @media (max-width: 1025px) {
    margin-right: 0px;
  }
`;

const PrimaryButton = styled(RoundedGradientButton)`
  width: fit-content !important;
  background: linear-gradient(to right, #807fef 23%, #b3abfa 64%, #c7bdff 79%);

  @media (max-width: 1025px) {
    margin-right: 0px;
  }

  @media (max-width: 768px) {
    margin-right: 0px;
  }
`;

const BookDemoLink = styled.button`
  height: 100%;
  background: #7e83f5;
  display: flex;
  justify-content: center;
  border-radius: 40px;
  border-color: transparent;
  color: #fff;
  font-size: 1rem;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 600;
  text-align: center;
  align-items: center;
  padding: 0 40px;
  width: 100%;
  justify-content: center;
  cursor: pointer;

  &:hover {
    color: #fff;
    background: transparent;
    &:after {
    }
  }
`;

const SignInLink = styled.a`
  height: 51px !important;
  display: flex;
  border-radius: 40px;
  color: #fff;
  text-align: center;
  line-height: normal;
  background: #0d2c99;
  color: #00d5ff;
  padding: 0 40px;
  align-items: center;
  justify-content: center;
  max-width: 291.81px !important;
  &:hover {
    color: white;
    background: #00d5ff;
    &:after {
    }
  }
`;

const SecondaryButton = styled(RoundedGradientButton)`
  width: fit-content !important;
  background: #00d5ff;

  @media (max-width: 1025px) {
    margin-right: 0px;
  }

  @media (max-width: 768px) {
    display: inline-block;
    box-sizing: border-box;
    width: 100% !important;
    max-width: 297.81px !important;
    margin-right: 0px;
    height: 100%;
  }
`;

const BottomDecoration = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 150px;
  background: white;
  clip-path: polygon(0% 100%, 0% 0%, 80% 100%);
  z-index: 0;

  @media (max-width: 767px) {
    z-index: 1;
    height: 95px;
  }
`;

const BottomDecoration2 = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 80%;
  height: 150px;
  background: linear-gradient(
    78deg,
    #807fef 22.43%,
    #6b9df4 53.55%,
    #40e0ff 111.27%
  );
  clip-path: polygon(100% 0, 30% 100%, 100% 100%);
  z-index: 0;

  @media (max-width: 767px) {
    z-index: 0;
  }
`;

const LeftContent = styled.div`
  width: 40%;
  z-index: 2;
  padding: 7rem 0rem 18rem 7rem;

  @media (max-width: 1025px) {
    width: 100%;
    padding: 0px;
  }
`;

const RightContent = styled.div`
  width: fit-content;
  height: fit-content;
  padding: 5rem 0rem 10rem 1rem;

  @media (max-width: 1025px) {
    width: 100%;
    padding: 0px;
    height: 100%;
    margin-top: 600px;
  }
`;

const DashboardImageContainer = styled.div`
  width: fit-content;
  height: 100%;
  overflow: hidden;
`;

const DashboardImage = styled.img`
  position: absolute;
  object-fit: cover;
  object-position: left center;
  width: 50%;
  height: 100%;
  z-index: 0;
  right: 0;
  bottom: 0;

  @media (max-width: 1025px) {
    width: 750px;
    height: 600px;
  }
`;

const TitleContainer = styled.div`
  margin-bottom: 20px;
  margin-top: 20px;
  width: fit-content;

  @media (max-width: 1025px) {
    width: 100%;
    margin-top: 16px;
    text-align: center;
  }

  @media (max-width: 767px) {
    max-width: 100%;
    width: fit-content;
    padding: 0px 16px;
    margin-top: 16px;
    text-align: center;
    align-items: center;
  }
`;

const Title = styled.h2`
  margin: 0;
  font-size: 56px;
  font-weight: 550;
  color: #fff;
  span {
    color: #40eeff;
  }

  @media (max-width: 767px) {
    font-size: 52px;
    font-weight: 500;
    text-align: center;
    width: 100%;
  }
`;

const DesktopBreak = styled.br`
  display: none;

  @media (min-width: 767px) {
    display: inline;
  }
`;

// This section is commented out because the component will be hide until further notice.
// const FeatureCard = () => {
//   const isTablet = useScreenWidthRange(768, 1024);
//   const isMobile = useScreenWidthRange(0, 767);

//   return (
//     <FeatureCardContainer>
//       <Card>
//         <Stack
//           direction={isMobile ? "column" : "row"}
//           spacing={"12px"}
//           sx={{ width: "100%" }}
//           alignItems={"center"}
//         >
//           <Stack
//             direction={"row"}
//             spacing={isMobile ? "24px" : "12px"}
//             alignItems={"center"}
//             sx={{ width: isMobile ? "100%" : "fit-content" }}
//           >
//             <BulbIconContainer>
//               <BulbIcon src={bulbIcon} />
//             </BulbIconContainer>
//             <BannerTitle>
//               Introducing{" "}
//               <br style={{ display: isMobile ? "none" : "inline" }} /> New
//               Features
//             </BannerTitle>
//           </Stack>
//           <div
//             style={{
//               flex: 8
//             }}
//           >
//             <BannerDescription>
//               Begin with the essentials in our core module, designed to
//               outperform the systems you're used to.
//             </BannerDescription>
//           </div>
//           <div
//             style={{
//               flex: isTablet ? 1 : 2,
//               width: "100%"
//             }}
//           >
//             {isTablet ? (
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   width: "100%",
//                   justifyContent: "right"
//                 }}
//               >
//                 <FeatureArrow src={featureArrow} alt={"Go"} />
//               </div>
//             ) : (
//               <RoundedGradientButton>
//                 <LearnMoreLink to="/under-maintenance">
//                   Learn More
//                 </LearnMoreLink>
//               </RoundedGradientButton>
//             )}
//           </div>
//         </Stack>
//       </Card>
//     </FeatureCardContainer>
//   );
// };

// const FeatureArrow = styled.img`
//   width: 48px;
//   height: 48px;
//   margin-top: 0px;
// `;

// const BannerTitle = styled.h2`
//   font-size: 30px;
//   line-height: 1.3833333333333333;
//   color: #002671;

//   @media (max-width: 767px) {
//     text-align: left;
//     margin: 0;
//     font-size: 1.8rem;
//   }
// `;

// const FeatureCardContainer = styled.div`
//   margin: 0 140px;
//   width: fit-content;

//   @media (max-width: 1025px) {
//     margin: 0 40px;
//     display: flex;
//     align-items: center;
//   }

//   @media (max-width: 767px) {
//     margin: 0 10px;
//   }
// `;

// const Card = styled.div`
//   background-color: #f0f4ff;
//   border-radius: 40px;
//   padding: 32px;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
//   flex-wrap: wrap;

//   @media (max-width: 1025px) {
//     padding: 24px 40px;
//   }

//   @media (max-width: 767px) {
//     flex-direction: column;
//     text-align: left;
//     gap: 1rem;
//     padding: 32px;
//   }
// `;

// const BannerDescription = styled.p`
//   font-size: 1.2rem;
//   margin-top: 1rem;
//   line-height: 1.5;
//   padding-right: 2rem;
//   padding-left: 2rem;

//   @media (max-width: 1025px) {
//     padding: 0px 32px 0px 24px;
//     margin: 0;
//   }

//   @media (max-width: 767px) {
//     padding: 0;
//     margin: 0;
//     font-size: 1rem;
//   }
// `;

// const LearnMoreLink = styled(Link)`
//   height: 100%;
//   background: #7e83f5;
//   display: flex;
//   justify-content: center;
//   border-radius: 40px;
//   color: #fff;
//   text-align: center;

//   &:hover {
//     color: #fff;
//     background: transparent;
//     &:after {
//     }
//   }
// `;

// const FeatureContainer = styled.div`
//   transform: translateY(-50%);
//   position: absolute;
//   width: 100%;
//   display: flex;
//   justify-content: center;
//   z-index: 5;
// `;

// const BulbIconContainer = styled.div`
//   width: fit-content;
//   height: 64px;
//   background-size: contain;
//   background-repeat: no-repeat;
// `;

// const BulbIcon = styled.img`
//   width: 100%;
//   height: auto;

//   @media (max-width: 767px) {
//     width: 64px;
//     height: auto;
//   }
// `;

export default LandingOne;
